// avstemming-vat-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avf.common.matches': 'Cuadra',
  'avf.common.submitted': 'Presentada',
  'avf.common.notSubmitted': 'No presentada',
  'avf.common.complete': 'Completa',
  'avf.common.differences': '{count} diferencia(s)',
  'avf.common.difference': 'Diferencia',
  'avf.common.needsAssessment': 'Requiere valoración',
  'avf.common.status': 'Estado',
  'avf.common.all': 'Todas',
  'avf.common.missingTreatment': 'Tratamiento del IVA sin determinar',
  'avf.common.directPosting': 'Contabilización directa',
  'avf.common.postedDirectly': 'Contabilizado directamente en cuenta de IVA',
  'avf.common.noDeduction': 'Sin derecho a deducción',
  'avf.common.partialDeduction': 'Derecho a deducción parcial',
  'avf.common.reverseCharge': 'Inversión del sujeto pasivo',
  'avf.common.salesWithoutVat': 'Ventas sin IVA',
  'avf.common.creditNotes': 'Notas de crédito',
  'avf.common.assessed': 'Valoradas',
  'avf.common.salesOutgoing': 'Ventas e IVA repercutido',
  'avf.common.purchasesIncoming': 'Compras e IVA soportado',
  'avf.common.sales': 'Ventas',
  'avf.common.purchases': 'Compras',
  'avf.common.foreign': 'Extranjero',
  'avf.common.assess': 'Valorar',
  'avf.common.viewAssessment': 'Ver valoración',
  'avf.common.requestDocs': 'Pedir documentación al cliente',
  'avf.common.close': 'Cerrar',
  'avf.common.followUpNext': 'Seguimiento en el próximo periodo',
  'avf.common.missing': 'Falta',
  'avf.common.outgoingInTerm': 'IVA repercutido en el periodo',
  'avf.common.incomingInTerm': 'IVA soportado en el periodo',
  'avf.common.filingDeadline': 'Fecha límite de presentación',
  'avf.common.reportingPeriod': 'Periodo de declaración',
  'avf.common.documentation': 'Documentación',
  'avf.common.filingTitle': 'Declaración de IVA',
  'avf.common.col.document': 'Documento',
  'avf.common.col.documentDate': 'Fecha del documento',
  'avf.common.col.account': 'Cuenta',
  'avf.common.col.vatCode': 'Código de IVA',
  'avf.common.col.vatAmount': 'Importe de IVA',
  'avf.common.col.rate': 'Tipo',
  'avf.common.col.warning': 'Aviso',
  'avf.common.col.assessment': 'Valoración',
  'avf.common.col.counterparty': 'Contraparte',
  'avf.common.col.type': 'Tipo',
  'avf.common.col.basis': 'Base',
  'avf.common.col.date': 'Fecha',
  'avf.common.col.amount': 'Importe',
  'avf.common.col.deductionRate': 'Porcentaje de deducción',
  'avf.term.monthly': 'Mensual',
  'avf.term.bimonthly': 'Bimestral',
  'avf.term.quarterly': 'Trimestral',
  'avf.term.semiannual': 'Semestral',
  'avf.term.annual': 'Anual',
  'avf.assess.notAssessed': 'Sin valorar',
  'avf.assess.noCorrection': 'No requiere corrección',
  'avf.assess.missingCode': 'Código de IVA ausente',
  'avf.assess.wrongCode': 'Código de IVA incorrecto',
  'avf.assess.wrongRate': 'Tipo incorrecto',
  'avf.assess.limitedDeduction': 'Derecho a deducción limitado',
  'avf.assess.importVat': 'IVA a la importación',
  'avf.assess.wrongTerm': 'Declarado en un periodo incorrecto',
  'avf.assess.duplicate': 'Duplicado',
  'avf.assess.awaitingDocs': 'A la espera de documentación',
  'avf.assess.awaitingClient': 'A la espera del cliente',
  'avf.page.noAccount': 'El área de IVA no tiene ninguna cuenta de conciliación en este periodo.',
  'avf.page.nav.overview': 'Resumen',
  'avf.page.nav.codes': 'Códigos de IVA y base',
  'avf.page.nav.codesCount': '{count} códigos',
  'avf.page.nav.toAssess': '{count} por valorar',
  'avf.page.nav.foreign': 'Extranjero e importación',
  'avf.page.nav.items': '{count} partidas',
  'avf.page.nav.accounts': 'Cuentas de IVA',
  'avf.page.nav.accountsCount': '{count} cuentas',
  'avf.page.nav.filing': 'Declaración de IVA y liquidación',
  'avf.page.nav.deviations': 'Desviaciones y medidas',
  'avf.page.nav.open': '{count} abiertas',
  'avf.page.nav.missing': 'faltan {count}',
  'avf.page.nav.controls': 'Control y aprobación',
  'avf.page.areaFallback': 'IVA',
  'avf.page.hintOpen': '{count} transacción(es) con aviso no se han valorado por completo.',
  'avf.page.hintDone': 'Todas las transacciones con aviso están valoradas.',
  'avf.page.title': 'IVA — base de transacciones, libro mayor y declaración de IVA',
  'avf.page.reconciledIn': 'Se concilia en {period}',
  'avf.page.responsible': 'Responsable: {name}',
  'avf.page.notRegisteredBadge': 'Sin registro de IVA',
  'avf.page.termOver': 'El periodo ha terminado',
  'avf.page.termRunning': 'El periodo está en curso',
  'avf.page.orgNumber': 'Número de organización',
  'avf.page.termLength': 'Duración del periodo',
  'avf.page.netInTerm': 'IVA neto en el periodo',
  'avf.page.termNotOver': 'El periodo no ha terminado.',
  'avf.page.termEnds': '{period} {year} termina el {date}, y la conciliación del IVA corresponde a ese mes.',
  'avf.page.termSoFar': 'Las cifras de abajo muestran el periodo hasta ahora. El área no cuenta para el avance en este periodo.',
  'avf.page.notRegistered': 'La empresa no está registrada en el registro de IVA en los ajustes. Si aun así se ha contabilizado IVA en el periodo, lo que hay que corregir es el registro o la contabilidad, no la conciliación.',
  'avf.ov.sources.title': 'Fuentes de datos',
  'avf.ov.sources.incompleteOne': '{count} fuente no está completa para el periodo.',
  'avf.ov.sources.incompleteMany': '{count} fuentes no están completas para el periodo.',
  'avf.ov.sources.allPresent': 'Todas las fuentes que lee la conciliación están disponibles para el periodo.',
  'avf.ov.sources.colSource': 'Fuente',
  'avf.ov.sources.colDetails': 'Detalles',
  'avf.ov.sources.notComplete': 'Incompleta',
  'avf.ov.main.title': 'Conciliación principal automática',
  'avf.ov.main.noAccounts': 'No hay cuentas de IVA que comparar',
  'avf.ov.main.codesMatch': 'Los códigos de IVA cuadran con el libro mayor',
  'avf.ov.main.noActivity': 'El periodo no tiene movimientos en las cuentas de IVA. Sin una cuenta con la que comparar, no hay ninguna diferencia que conciliar.',
  'avf.ov.main.sameTax': 'El impuesto que resulta de los códigos de IVA es el mismo que se ha contabilizado en las cuentas de IVA en el periodo.',
  'avf.ov.main.differentTax': 'El impuesto que resulta de los códigos de IVA no es el mismo que se ha contabilizado en las cuentas de IVA. La diferencia debe explicarse antes de poder conciliar el área.',
  'avf.ov.main.colArea': 'Área de control',
  'avf.ov.main.colCodes': 'Códigos de IVA',
  'avf.ov.main.colLedger': 'Libro mayor',
  'avf.ov.main.notCompared': 'Sin comparar',
  'avf.ov.codes.title': 'Códigos de IVA y base de declaración',
  'avf.ov.codes.none': 'No hay códigos de IVA con importes en este periodo.',
  'avf.ov.codes.explain': 'La base son las transacciones del periodo. El IVA calculado es la base multiplicada por el tipo; si difiere del importe del propio código, el impuesto se ha calculado sobre algo distinto de la base.',
  'avf.ov.codes.colDescription': 'Descripción',
  'avf.ov.codes.colComputed': 'IVA calculado',
  'avf.ov.codes.colBooked': 'IVA contabilizado',
  'avf.ov.codes.noRate': 'Sin tipo',
  'avf.ov.accounts.title': 'Cuentas de IVA en el libro mayor',
  'avf.ov.accounts.none': 'Ninguna cuenta de IVA tiene saldo ni movimientos en este periodo.',
  'avf.ov.accounts.colAccount': 'Cuenta de control',
  'avf.ov.accounts.colOpening': 'Saldo inicial',
  'avf.ov.accounts.colDebit': 'Debe',
  'avf.ov.accounts.colCredit': 'Haber',
  'avf.ov.accounts.colClosing': 'Saldo final',
  'avf.ov.accounts.colExpected': 'Calculado a partir de los códigos de IVA',
  'avf.ov.accounts.carriedOver': 'No saldada desde el periodo anterior',
  'avf.ov.accounts.noCodePoints': 'Ningún código apunta aquí',
  'avf.ov.accounts.open': 'Abrir cuenta',
  'avf.ov.accounts.sumOutgoing': 'Total de IVA repercutido en el periodo',
  'avf.ov.accounts.sumIncoming': 'Total de IVA soportado en el periodo',
  'avf.ov.accounts.bookedOn': 'Contabilizado en {accounts}',
  'avf.ov.accounts.carriedNote': '{codes}: el saldo no se ha saldado tras el periodo anterior. Comprueba si el importe corresponde a una liquidación sin pagar o a un error de contabilización.',
  'avf.ov.tile.duplicateVouchers': 'Posibles justificantes duplicados',
  'avf.ov.tile.customsMissing': 'Falta la declaración de aduana',
  'avf.ov.tile.creditNotesInPeriod': 'Notas de crédito en el periodo',
  'avf.ov.card.title': 'Tarjeta de control',
  'avf.ov.card.summary': '{flagged} transacciones afectadas · {unassessed} sin valorar por completo',
  'avf.ov.card.codesVsLedger': 'Códigos de IVA frente al libro mayor',
  'avf.ov.card.seeMain': 'Ver la conciliación principal',
  'avf.ov.card.settlementNotCleared': 'Cuenta de liquidación sin saldar',
  'avf.ov.card.hide': 'Ocultar',
  'avf.ov.card.showAll': 'Mostrar todos los controles automáticos',
  'avf.ov.card.activeFilter': 'Filtro activo: {label} · {count} transacciones',
  'avf.ov.card.reset': 'Restablecer',
  'avf.ov.checks.title': 'Controles automáticos',
  'avf.ov.checks.note': 'Los controles no marcan nada en la lista de verificación profesional. Indican qué debería haber revisado quien la marca.',
  'avf.ov.checks.colCheck': 'Control',
  'avf.ov.checks.colRun': 'Ejecución',
  'avf.ov.checks.colFindings': 'Hallazgos',
  'avf.ov.checks.run': 'Ejecutado',
  'avf.ov.checks.findings': '{count} hallazgos',
  'avf.ov.checks.noFindings': 'Sin hallazgos',
  'avf.tbl.possibleDuplicates': 'Posibles duplicados',
  'avf.tbl.duplicates': 'Duplicados',
  'avf.tbl.foreignReverse': 'Extranjero/inversión',
  'avf.tbl.import': 'Importación',
  'avf.tbl.sales.totalBasis': 'Base total de ventas',
  'avf.tbl.sales.taxableTurnover': 'Volumen de negocios sujeto a impuesto',
  'avf.tbl.sales.outputVat': 'IVA repercutido',
  'avf.tbl.sales.toAssess': 'Transacciones por valorar',
  'avf.tbl.sales.colCustomer': 'Cliente',
  'avf.tbl.sales.colNetBasis': 'Base neta',
  'avf.tbl.sales.noMatch': 'Ninguna transacción de venta coincide con los filtros.',
  'avf.tbl.sales.none': 'No hay ventas en este periodo.',
  'avf.tbl.purchases.totalBasis': 'Base total de compras',
  'avf.tbl.purchases.deductedInputVat': 'IVA soportado deducido',
  'avf.tbl.purchases.withoutDeduction': 'Sin derecho a deducción',
  'avf.tbl.purchases.partialDeduction': 'Deducción parcial',
  'avf.tbl.purchases.toAssess': 'Compras por valorar',
  'avf.tbl.purchases.colSupplier': 'Proveedor',
  'avf.tbl.purchases.noMatch': 'Ninguna transacción de compra coincide con los filtros.',
  'avf.tbl.purchases.none': 'No hay compras en este periodo.',
  'avf.tbl.control.title': 'Control de transacciones',
  'avf.tbl.control.resetFilters': 'Restablecer filtros',
  'avf.tbl.control.noMatch': 'Ninguna transacción coincide con los filtros.',
  'avf.tbl.control.none': 'No hay transacciones con efecto en el IVA en este periodo.',
  'avf.sec.status.paid': 'Presentada y pagada',
  'avf.sec.status.unpaid': 'Presentada — sin pagar',
  'avf.sec.status.upcoming': 'El periodo no ha comenzado',
  'avf.sec.status.archive': 'Base de archivo procedente de importación',
  'avf.sec.status.unknown': 'Estado desconocido',
  'avf.sec.noFlags': 'Ninguno',
  'avf.sec.moreFlags': '+{count} más',
  'avf.sec.customs.registered': 'Registrada',
  'avf.sec.customs.notRelevant': 'No aplica',
  'avf.sec.foreign.title': 'Extranjero, importación e inversión del sujeto pasivo',
  'avf.sec.foreign.none': 'No hay compras con inversión del sujeto pasivo ni importaciones de mercancías en este periodo.',
  'avf.sec.foreign.count': 'Número de transacciones con el extranjero',
  'avf.sec.foreign.reverseBasis': 'Base de la inversión del sujeto pasivo',
  'avf.sec.foreign.computedOutput': 'IVA repercutido calculado',
  'avf.sec.foreign.deductibleInput': 'IVA soportado deducible',
  'avf.sec.foreign.customsRegistered': 'Declaraciones de aduana registradas',
  'avf.sec.foreign.customsMissing': 'Declaraciones de aduana que faltan',
  'avf.sec.foreign.colOutput': 'IVA repercutido',
  'avf.sec.foreign.colInput': 'IVA soportado',
  'avf.sec.foreign.colCustoms': 'Documento de aduana',
  'avf.sec.foreign.missingOne': 'Una importación de mercancías no tiene ninguna declaración de aduana registrada en el periodo. La base de la importación no puede contrastarse con nada y el IVA a la importación se apoya solo en el importe contabilizado.',
  'avf.sec.foreign.missingMany': '{count} importaciones de mercancías no tienen ninguna declaración de aduana registrada en el periodo. La base de la importación no puede contrastarse con nada y el IVA a la importación se apoya solo en el importe contabilizado.',
  'avf.sec.foreign.requestCustoms': 'Pedir la declaración de aduana al cliente',
  'avf.sec.draft.titleSubmitted': 'Resumen de la declaración de IVA',
  'avf.sec.draft.titleDraft': 'Resumen de la declaración de IVA (borrador)',
  'avf.sec.draft.badge': 'Borrador',
  'avf.sec.draft.totalOutput': 'Total de IVA repercutido',
  'avf.sec.draft.totalDeductible': 'Total de IVA soportado a deducir',
  'avf.sec.draft.importReverse': 'IVA en importación e inversión del sujeto pasivo',
  'avf.sec.draft.importIncomplete': 'Incompleto — consulta Extranjero e importación',
  'avf.sec.draft.netRefund': 'IVA neto a devolver',
  'avf.sec.draft.netPayable': 'IVA neto a pagar',
  'avf.sec.draft.deviation': 'Desviación respecto a la cifra del modelo de IVA para el periodo',
  'avf.sec.draft.submittedNote': 'La declaración está presentada. La conciliación comprueba que la base que hay detrás es correcta.',
  'avf.sec.draft.notSentNote': 'La declaración no se ha enviado: el importe puede cambiar cuando se traten los hallazgos de control.',
  'avf.sec.filing.noTerm': 'El periodo no pertenece a ningún periodo de IVA en {year}.',
  'avf.sec.filing.yearFallback': 'el año',
  'avf.sec.filing.covers': 'El periodo abarca',
  'avf.sec.filing.netRefund': 'Neto a devolver',
  'avf.sec.filing.netToPay': 'Neto a pagar',
  'avf.sec.filing.submittedNote': 'La declaración del periodo está presentada. La conciliación comprueba que la base que hay detrás es correcta.',
  'avf.sec.filing.notSubmittedNote': 'La declaración no está presentada. Se envía desde la página de IVA del propio cliente: la conciliación concluye, no declara.',
  'avf.sec.filing.declarations': '{count} declaración(es) de aduana registrada(s) en el periodo.',
  'avf.sec.settle.title': 'Liquidación y pago',
  'avf.sec.settle.refundAmount': 'Importe a devolver',
  'avf.sec.settle.claim': 'Importe según la declaración',
  'avf.sec.settle.refunded': 'Devuelto',
  'avf.sec.settle.paid': 'Pagado',
  'avf.sec.settle.outstanding': 'Pendiente',
  'avf.sec.settle.paymentDeadline': 'Fecha límite de pago',
  'avf.sec.settle.refundRow': 'Devolución',
  'avf.sec.settle.paymentRow': 'Pago',
  'avf.sec.settle.noPayment': 'Todavía no se ha registrado ningún pago en el periodo.',
  'avf.sec.settle.cannotFinish': 'La liquidación no puede finalizarse hasta que la declaración esté presentada y el pago registrado.',
  'avf.sec.docs.colUploaded': 'Subido',
  'avf.sec.docs.sourceClient': 'El cliente',
  'avf.sec.docs.sourceFirm': 'El despacho',
  'avf.sec.docs.none': 'No se ha subido ningún documento al área de IVA para este periodo.',
  'avf.sec.docs.incompleteBasis': 'Base que no está completa',
  'avf.chk.derived.missingTreatment': 'Las transacciones sin tratamiento del IVA determinado se han tratado',
  'avf.chk.derived.direct': 'Las contabilizaciones directas en las cuentas de IVA se han valorado',
  'avf.chk.derived.duplicates': 'Los posibles duplicados se han valorado',
  'avf.chk.derived.noDeduction': 'Las compras sin derecho a deducción se han valorado',
  'avf.chk.derived.partialDeduction': 'Las compras con derecho a deducción parcial se han valorado',
  'avf.chk.derived.reverseCharge': 'La inversión del sujeto pasivo se ha valorado',
  'avf.chk.derived.customsMissing': 'Las importaciones de mercancías sin declaración de aduana se han tratado',
  'avf.chk.derived.salesWithoutVat': 'Las ventas sin IVA están documentadas',
  'avf.chk.derived.creditNotes': 'La periodificación de las notas de crédito se ha valorado',
  'avf.chk.title': 'Lista de verificación profesional',
  'avf.chk.titleReadOnly': 'Lista de verificación profesional (del ejecutor, solo lectura)',
  'avf.chk.none': 'No hay puntos de control definidos para el IVA en este periodo.',
  'avf.chk.note': 'Los puntos se aplican a toda el área de IVA. Una marca se guarda en todas las cuentas de IVA del periodo.',
  'avf.chk.groupItems': 'Partidas que requieren tratamiento',
  'avf.chk.groupAssessments': 'Valoraciones profesionales generales',
  'avf.chk.groupReady': 'Preparación final',
  'avf.chk.countOf': '{done} de {total}',
  'avf.chk.processed': '{done} de {total} tratadas',
  'avf.chk.notApplicable': 'No aplica este periodo',
  'avf.chk.followsAssessments': 'Se deriva de las valoraciones',
  'avf.chk.performedBy': 'Realizado por {name}',
  'avf.chk.completed': '{done} de {total} puntos de control completados',
  'avf.chk.blk.itemsOne': '{count} transacción requiere valoración',
  'avf.chk.blk.itemsMany': '{count} transacciones requieren valoración',
  'avf.chk.blk.diff': 'Los códigos de IVA y el libro mayor difieren en {areas}',
  'avf.chk.blk.settlement': 'La cuenta de liquidación no se ha saldado desde el periodo anterior',
  'avf.chk.blk.customs': 'A {count} importación(es) de mercancías le falta la declaración de aduana',
  'avf.chk.blk.checksOne': 'Queda {count} punto de control',
  'avf.chk.blk.checksMany': 'Quedan {count} puntos de control',
  'avf.chk.concl.title': 'Conclusión y aprobación',
  'avf.chk.concl.label': 'Conclusión',
  'avf.chk.concl.placeholder': '¿Qué muestra la revisión del IVA de este periodo?',
  'avf.chk.concl.savedAs': 'Se guarda como justificación del punto de control «{label}».',
  'avf.chk.concl.remainingRisk': 'Riesgo pendiente',
  'avf.chk.concl.nothingLeft': 'No queda nada que impida enviar el área a control.',
  'avf.chk.concl.followUpTitle': 'Seguimiento en el próximo periodo',
  'avf.chk.concl.noFollowUps': 'Ninguna valoración está marcada para seguimiento en el próximo periodo.',
  'avf.chk.concl.followedUp': 'En seguimiento',
  'avf.chk.concl.action': 'Medida: {action}',
  'avf.chk.concl.noAction': 'Ninguna medida anotada',
  'avf.chk.concl.due': 'Fecha límite {date}',
  'avf.chk.concl.openAssessment': 'Abrir valoración',
  'avf.chk.concl.sendToControl': 'Enviar el área a control',
  'avf.chk.concl.oneLeft': 'Queda una cosa antes de poder enviar el área.',
  'avf.chk.concl.manyLeft': 'Quedan {count} cosas antes de poder enviar el área.',
  'avf.drw.outputReverse': 'IVA repercutido (inversión)',
  'avf.drw.reason': 'Justificación profesional',
  'avf.drw.reasonRequired': 'Justificación profesional (obligatoria)',
  'avf.drw.reasonPlaceholder': '¿Por qué se ha tratado así el impuesto y en qué se basa la valoración?',
  'avf.drw.action': 'Medida',
  'avf.drw.actionPlaceholder': 'P. ej. Corregir el código de IVA en el justificante o pedir documentación',
  'avf.drw.followUpDeadline': 'Fecha límite de seguimiento',
  'avf.drw.needsReason': 'Esta valoración requiere una justificación.',
  'avf.drw.save': 'Guardar valoración',
});
